import React, { useRef } from 'react';
import DatePickerComponent, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import zhCN from 'date-fns/locale/zh-CN';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';
registerLocale('ru', ru);
registerLocale('zh-CN', zhCN);

const Wrapper = styled('div')`
  i {
    position: absolute;
    opacity: 0.5;
    font-size: 16px;
    right: 9px;
    top: 10px;
    cursor: pointer;
  }
`;

const DatePicker = (props) => {
  const {
    dateFormat = 'dd.MM.yyyy',
    selected,
    onChange,
    onChangeRaw = undefined,
    minDate = null,
    maxDate = null,
    showTimeSelect = false,
    showTimeSelectOnly = false,
    timeIntervals = undefined,
    timeCaption = 'Время',
    minTime = undefined,
    maxTime = undefined,
    inline = false,
    readOnly = false,
    placeholderText = '',
    icon = false,
    isClearable = false,
  } = props;

  const datepickerRef = useRef(null);

  const { i18n } = useAutoTranslation();

  const currentLocale = i18n.language === 'cn' ? 'zh-CN' : 'ru';

  function handleClickDatepickerIcon() {
    const datepickerElement = datepickerRef.current;
    datepickerElement.setFocus(true);
  }

  return !icon ? (
    <DatePickerComponent
      className="form-control"
      locale={currentLocale}
      dateFormat={dateFormat}
      selected={selected}
      minDate={minDate}
      maxDate={maxDate}
      minTime={minTime}
      maxTime={maxTime}
      showTimeSelect={showTimeSelect}
      showTimeSelectOnly={showTimeSelectOnly}
      timeIntervals={timeIntervals}
      timeCaption={timeCaption}
      onChange={onChange}
      onChangeRaw={onChangeRaw}
      inline={inline}
      readOnly={readOnly}
      placeholderText={placeholderText}
      isClearable={isClearable}
    />
  ) : (
    <Wrapper>
      <DatePickerComponent
        className="form-control"
        locale={currentLocale}
        dateFormat={dateFormat}
        selected={selected}
        minDate={minDate}
        maxDate={maxDate}
        minTime={minTime}
        maxTime={maxTime}
        showTimeSelect={showTimeSelect}
        showTimeSelectOnly={showTimeSelectOnly}
        timeIntervals={timeIntervals}
        timeCaption={timeCaption}
        onChange={onChange}
        onChangeRaw={onChangeRaw}
        placeholderText={placeholderText}
        ref={datepickerRef}
        isClearable={isClearable}
      />
      <i className="fe-calendar" onClick={() => handleClickDatepickerIcon()}></i>
    </Wrapper>
  );
};

export default DatePicker;
